<template>
  <app-notification
    class="d-flex"
    :type="type"
    v-if="items.length"
  >
    <fa-icon
      class="margin__r--6 margin__t--6"
      :class="{ 'color--danger': type === 'error' }"
      size="sm"
      :icon="icon"
    />

    <ul class="list">
      <li
        class="list__item"
        v-for="(key, index) in items"
        :key="index"
      >
        <slot :key="key">
          {{ t(key) }}
        </slot>
      </li>
    </ul>
  </app-notification>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { get as _get, isPlainObject as _isPlainObject } from 'lodash'

const AppNotification = defineAsyncComponent(() => import('&/atoms/AppNotification'))

const { keys, type } = defineProps({
  keys: { type: [Object, String, Array] },
  type: { type: String, default: 'error' }
})

const { t, getKey } = useI18n()

const types = {
  error: ['fal', 'exclamation-circle']
}

const icon = computed(() => types[type])
const rawKeys = computed(() => _isPlainObject(keys) ? _get(keys, 'data.errors', null) : keys)
const items = computed(() => (Array.isArray(rawKeys.value) ? rawKeys.value.map(key => createKey(key)) : [createKey(rawKeys.value)]).filter(key => key))

const createKey = key => key && type === 'error' && !key.startsWith('errors.') ? `errors.${getKey(key)}` : key
</script>

<style scoped lang="scss">
.list {
  &__item:not(:first-child) {
    margin-top: 12px;
  }
}
</style>
